import {MyButtonStyles} from "./MyButton.styles";
import {MyButtonProps} from "./MyButton.props";
import cl from "classnames";
import React from "react";

export const MyButton = ({
                           title,
                           width = 'auto',
                           height = 'auto',
                           background,
                           info = false,
                           warning = false,
                           children,
                           className,
                           ...props
                         }: MyButtonProps): React.ReactElement => {

  return (
    <MyButtonStyles {...props} style={{width: width, background: background, height: height, ...props.style}}
                    className={cl(className, {
      'ant-btn-warning': warning,
      'ant-btn-info': info,
    })}>
      {title}
      {children}
    </MyButtonStyles>
  )
}